import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/content';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  tone?: 'mustard' | 'ink';
  size?: 'lg' | 'block';
  className?: string;
};
export function CtaButton({
  children,
  href = checkoutUrl,
  tone = 'mustard',
  size = 'block',
  className = ''
}: CtaButtonProps) {
  const tones = {
    mustard: 'bg-mustard text-ink hover:bg-mustard-bright focus-visible:outline-mustard',
    ink: 'bg-ink text-ivory hover:bg-ink-raise focus-visible:outline-ink'
  };
  const sizes = {
    lg: 'px-8 py-4',
    block: 'w-full px-4 py-[1.1rem]'
  };
  const isExternal = href.startsWith('http');
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`inline-flex min-w-0 max-w-full items-center justify-center gap-2 text-balance rounded-full text-center font-sans text-[clamp(0.8rem,3.6vw,0.9rem)] font-bold leading-tight tracking-tight shadow-[0_10px_24px_-12px_rgba(0,0,0,0.5)] transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 sm:text-base ${tones[tone]} ${sizes[size]} ${className}`} data-id="element-39" data-mp="vb0k6dk9awly">
      {children}
      <ArrowRightIcon className="h-4 w-4 flex-none" aria-hidden="true" data-id="element-40" data-mp="3jy8lfze12eh3" />
    </a>;
}